var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Rect } from "./position";
export var ComponentType;
(function (ComponentType) {
    ComponentType["shelf"] = "SHELF";
    ComponentType["module"] = "MODULE";
    ComponentType["group"] = "GROUP";
})(ComponentType || (ComponentType = {}));
export function findComponentsUnderOffset(offset, components) {
    return components.filter(function (component) {
        return ((component.type === ComponentType.shelf ||
            component.type === ComponentType.module) &&
            component.position.isCollidingWith(Rect.fromSize({
                height: 0,
                width: 0,
                x: offset.x,
                y: offset.y
            })));
    });
}
export function isCaddy(component) {
    return component.type === ComponentType.shelf && component.data.isCaddy;
}
/**
 * Traverve the component tree to find the nearest Group instance.
 */
export function findGroupFromAncestors(component) {
    for (var parent = component.parent; !!parent; parent = parent.parent) {
        if (parent.type === ComponentType.group) {
            return parent;
        }
    }
    return undefined;
}
export function globalToLocalOffset(global, component) {
    return {
        x: global.x - component.data.x,
        y: global.y - component.data.y
    };
}
/**
 * Compute the vertical offset of a shelf when drop at `offset` inside `caddy`
 *
 * This vertical offset is "reversed" where 0 is visually the top of the `caddy`.
 * `offset` be passed through `globalToLocalOffset` before.
 * So that 0/0 always correspond to the top left of the caddy.
 */
export function computeShelfVerticalOffsetInCaddy(caddy, offset) {
    var pitch = caddy.data.caddyLaddersPitch;
    var bottomStep = caddy.data.height - caddy.data.padding.bottom;
    var innerHeight = caddy.data.height - caddy.data.padding.top - caddy.data.padding.bottom;
    var stepsCount = Math.floor(innerHeight / pitch);
    var topStep = bottomStep - stepsCount * pitch;
    if (pitch === 0 || offset.y >= bottomStep) {
        return bottomStep;
    }
    if (offset.y <= topStep) {
        return topStep;
    }
    for (var i = bottomStep; i > offset.y; i -= pitch) {
        if (i - pitch / 2 <= offset.y) {
            return i;
        }
        if (i - pitch <= offset.y) {
            return i - pitch;
        }
    }
    throw Error("Failed to find a step to attach to");
}
/**
 * Check if a Shelf is too big/small to fit inside a caddy.
 */
export function isShelfCompatibleWithCaddy(shelfData, caddy) {
    return (caddy.data.width - caddy.data.padding.left - caddy.data.padding.right ===
        shelfData.width);
}
// TODO: add some tests
export function getShelf2CaddyDestination(allComponents, pos, shelfData) {
    var caddyUnderMouse = findComponentsUnderOffset(pos, allComponents.filter(function (component) { return component.data.id !== shelfData.id && isCaddy(component); }))[0];
    if (!caddyUnderMouse ||
        !isShelfCompatibleWithCaddy(shelfData, caddyUnderMouse)) {
        return [undefined, undefined];
    }
    var localPos = globalToLocalOffset(pos, caddyUnderMouse);
    var vericalOffset = computeShelfVerticalOffsetInCaddy(caddyUnderMouse, localPos);
    var destination = {
        x: caddyUnderMouse.data.x + caddyUnderMouse.data.padding.left,
        y: caddyUnderMouse.data.y + vericalOffset - shelfData.height
    };
    var destinatonPostition = Rect.fromSize(__assign(__assign({}, destination), { height: shelfData.height, width: shelfData.width }));
    var clash = allComponents.some(function (c) {
        return c !== caddyUnderMouse &&
            c.type !== ComponentType.group &&
            c.position.isCollidingWith(destinatonPostition);
    });
    return clash ? [undefined, undefined] : [destination, caddyUnderMouse];
}



//////////////////
// WEBPACK FOOTER
// ../plano/dist/legacy.js
// module id = 3439
// module chunks = 0